import { sessionActions } from "./SessionReducer";
import { useSessionAPI  } from '../../api/session/useSessionAPI';

export const useSession = () => {
  const api = useSessionAPI();
  const request = {
      get: () => {
        return async (dispatch) => {
          try {
            const response = await api.get();
            dispatch(sessionActions.funGetSession(response));
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        }
      },
  };
  return { request };
};